import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = {
  key: 0,
  class: "col-fixed"
}
const _hoisted_5 = {
  key: 0,
  class: "flex flex-row flex-wrap"
}
const _hoisted_6 = { class: "col-12 xl:col-7" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "fluid grid" }
const _hoisted_9 = { class: "field col-12" }
const _hoisted_10 = {
  key: 0,
  class: "pi pi-lock"
}
const _hoisted_11 = {
  key: 1,
  class: "pi pi-lock-open"
}
const _hoisted_12 = {
  key: 0,
  class: "float-right label"
}
const _hoisted_13 = { class: "field col-12 md:col-6" }
const _hoisted_14 = { class: "field col-12 md:col-6" }
const _hoisted_15 = { class: "flex flex-nowrap" }
const _hoisted_16 = { class: "field col-12 md:col-6" }
const _hoisted_17 = { class: "field col-12 md:col-6" }
const _hoisted_18 = { class: "field col-12 md:col-6" }
const _hoisted_19 = { class: "field col-12 md:col-6" }
const _hoisted_20 = { class: "field col-12 md:col-6 xl:col-4" }
const _hoisted_21 = { class: "field col-12 md:col-6 xl:col-4" }
const _hoisted_22 = { class: "field col-12 md:col-6 xl:col-2" }
const _hoisted_23 = { class: "field col-12 md:col-6 xl:col-2" }
const _hoisted_24 = { class: "field col-12 md:col-6 xl:col-4" }
const _hoisted_25 = { class: "flex flex-nowrap" }
const _hoisted_26 = { class: "field col-12" }
const _hoisted_27 = { class: "field col-12" }
const _hoisted_28 = {
  class: "col-12 xl:col-5",
  style: {"align-self":"stretch"}
}
const _hoisted_29 = { class: "card" }
const _hoisted_30 = { style: {"margin-bottom":"5px"} }
const _hoisted_31 = { class: "flex align-items-end" }
const _hoisted_32 = { class: "flex flex-auto p-input-icon-left p-input-icon-right" }
const _hoisted_33 = { style: {"height":"536px"} }
const _hoisted_34 = {
  key: 0,
  class: "flex field"
}
const _hoisted_35 = {
  key: 1,
  class: "flex field"
}
const _hoisted_36 = {
  key: 2,
  class: "flex field"
}
const _hoisted_37 = { class: "col-12" }
const _hoisted_38 = { class: "card" }
const _hoisted_39 = {
  key: 1,
  class: "col-12"
}
const _hoisted_40 = { class: "card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ToggleButton = _resolveComponent("ToggleButton")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Contacts = _resolveComponent("Contacts")!
  const _component_BillingEntities = _resolveComponent("BillingEntities")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.getCompanyType) + ": " + _toDisplayString(_ctx.companyRecord.companyName), 1)
            ]),
            (!_ctx.loading && _ctx.isInternalUser)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", null, [
                    _createTextVNode("Active"),
                    _createElementVNode("br")
                  ], -1)),
                  _createVNode(_component_InputSwitch, {
                    modelValue: _ctx.companyRecord.active,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyRecord.active) = $event))
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("a", {
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.enableNameEdit && _ctx.enableNameEdit(...args)))
                        }, [
                          (_ctx.nameLocked)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                            : _createCommentVNode("", true),
                          (!_ctx.nameLocked)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.companyId > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, "# " + _toDisplayString(_ctx.companyId), 1))
                          : _createCommentVNode("", true),
                        _cache[23] || (_cache[23] = _createElementVNode("label", null, "Company name", -1)),
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.companyRecord.companyName,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.companyRecord.companyName) = $event)),
                          disabled: _ctx.nameLocked
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _cache[24] || (_cache[24] = _createElementVNode("label", null, "Company short name", -1)),
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.companyRecord.companyShortName,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.companyRecord.companyShortName) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _cache[27] || (_cache[27] = _createElementVNode("label", null, "Relationship", -1)),
                        _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_ToggleButton, {
                            modelValue: _ctx.companyRecord.isCustomer,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.companyRecord.isCustomer) = $event)),
                            onLabel: "Customer",
                            offLabel: "Customer"
                          }, null, 8, ["modelValue"]),
                          _cache[25] || (_cache[25] = _createTextVNode("   ", -1)),
                          _createVNode(_component_ToggleButton, {
                            modelValue: _ctx.companyRecord.isSupplier,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.companyRecord.isSupplier) = $event)),
                            onLabel: "Supplier",
                            offLabel: "Supplier"
                          }, null, 8, ["modelValue"]),
                          _cache[26] || (_cache[26] = _createTextVNode("   ", -1)),
                          _createVNode(_component_ToggleButton, {
                            modelValue: _ctx.companyRecord.isOwner,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.companyRecord.isOwner) = $event)),
                            onLabel: "Owner",
                            offLabel: "Owner"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _cache[29] || (_cache[29] = _createElementVNode("label", null, "Company Phone", -1)),
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.companyRecord.companyPhone,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.companyRecord.companyPhone) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _cache[30] || (_cache[30] = _createElementVNode("label", null, "Account No", -1)),
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.companyRecord.accountNumber,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.companyRecord.accountNumber) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _cache[31] || (_cache[31] = _createElementVNode("label", null, "Street Address", -1)),
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.companyRecord.streetAddress,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.companyRecord.streetAddress) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _cache[32] || (_cache[32] = _createElementVNode("label", null, "Postal Address", -1)),
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.companyRecord.postalAddress,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.companyRecord.postalAddress) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _cache[33] || (_cache[33] = _createElementVNode("label", null, "Suburb", -1)),
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.companyRecord.suburb,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.companyRecord.suburb) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _cache[34] || (_cache[34] = _createElementVNode("label", null, "City/Town", -1)),
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.companyRecord.city,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.companyRecord.city) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _cache[35] || (_cache[35] = _createElementVNode("label", null, "Postcode", -1)),
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.companyRecord.postCode,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.companyRecord.postCode) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _cache[36] || (_cache[36] = _createElementVNode("label", null, "Authority", -1)),
                        _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
                        _withDirectives(_createVNode(_component_InputSwitch, {
                          modelValue: _ctx.companyRecord.isAuthority,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.companyRecord.isAuthority) = $event))
                        }, null, 8, ["modelValue"]), [
                          [
                            _directive_tooltip,
                            'Mark as a Regional Authority (Council). This also determines North Island vs South Island location of properties assigned with this regional authority.',
                            void 0,
                            { top: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _cache[39] || (_cache[39] = _createElementVNode("label", null, "Island", -1)),
                        _cache[40] || (_cache[40] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("div", _hoisted_25, [
                          _withDirectives(_createVNode(_component_ToggleButton, {
                            modelValue: _ctx.northIsland,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.northIsland) = $event)),
                            onLabel: "North Island",
                            offLabel: "North Island",
                            onChange: _ctx.onIslandUpdate
                          }, null, 8, ["modelValue", "onChange"]), [
                            [
                              _directive_tooltip,
                              'This company operates in the North Island',
                              void 0,
                              { top: true }
                            ]
                          ]),
                          _cache[38] || (_cache[38] = _createTextVNode("   ", -1)),
                          _withDirectives(_createVNode(_component_ToggleButton, {
                            modelValue: _ctx.southIsland,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.southIsland) = $event)),
                            onLabel: "South Island",
                            offLabel: "South Island",
                            onChange: _ctx.onIslandUpdate
                          }, null, 8, ["modelValue", "onChange"]), [
                            [
                              _directive_tooltip,
                              'This company operates in the South Island',
                              void 0,
                              { top: true }
                            ]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _cache[41] || (_cache[41] = _createElementVNode("label", null, "Company Notes", -1)),
                        _createVNode(_component_TextArea, {
                          modelValue: _ctx.companyRecord.companyNotes,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.companyRecord.companyNotes) = $event)),
                          rows: "6",
                          autoResize: true
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        (!_ctx.newCompany)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              class: "float-left",
                              icon: "pi pi-trash",
                              label: "Delete",
                              onClick: _ctx.deleteCompany
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_Button, {
                          class: "float-right",
                          label: "Pricing Summary",
                          onClick: _ctx.pricingSummaryClick
                        }, null, 8, ["onClick"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _cache[44] || (_cache[44] = _createElementVNode("div", { style: {"padding":"5px","margin-right":"15px"} }, " Associated Properties ", -1)),
                        _createElementVNode("div", _hoisted_32, [
                          _cache[42] || (_cache[42] = _createElementVNode("i", { class: "pi pi-home" }, null, -1)),
                          _createVNode(_component_InputText, {
                            modelValue: _ctx.propertyListFilter,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.propertyListFilter) = $event)),
                            placeholder: "Property keyword filter..",
                            onInput: _ctx.filterProperties
                          }, null, 8, ["modelValue", "onInput"]),
                          _cache[43] || (_cache[43] = _createElementVNode("i", { class: "pi pi-search" }, null, -1))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_DataTable, {
                        value: _ctx.filteredAssociatedProperties,
                        scrollable: true,
                        style: {cursor:'pointer'},
                        onRowClick: _ctx.propertyClick,
                        datakey: "propertyId",
                        scrollHeight: "flex",
                        stripedRows: "",
                        class: "p-datatable-sm",
                        responsiveLayout: "scroll",
                        currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            field: "propertyId",
                            header: "ID",
                            style: {"flex-grow":"0","flex-basis":"80px"}
                          }),
                          _createVNode(_component_Column, {
                            field: "propertyNameAndLocation",
                            header: "Property"
                          })
                        ]),
                        _: 1
                      }, 8, ["value", "onRowClick"])
                    ])
                  ]),
                  (this.companyRecord.isSupplier && _ctx.companyRecord.associatedProperties && _ctx.companyRecord.associatedProperties.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createVNode(_component_InputSwitch, {
                          modelValue: _ctx.companyRecord.enableEmailAutomation,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.companyRecord.enableEmailAutomation) = $event))
                        }, null, 8, ["modelValue"]),
                        _cache[45] || (_cache[45] = _createElementVNode("div", { class: "label-beside-input-switch" }, "Enable supplier email automation (12A requests)", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (this.companyRecord.isCustomer && _ctx.companyRecord.associatedProperties && _ctx.companyRecord.associatedProperties.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createVNode(_component_InputSwitch, {
                          modelValue: _ctx.companyRecord.enableCustomerCcEmails,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.companyRecord.enableCustomerCcEmails) = $event))
                        }, null, 8, ["modelValue"]),
                        _cache[46] || (_cache[46] = _createElementVNode("div", { class: "label-beside-input-switch" }, "CC this customer on urgent and overdue emails (12A requests)", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (this.companyRecord.isCustomer && _ctx.companyRecord.associatedProperties && _ctx.companyRecord.associatedProperties.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createVNode(_component_InputSwitch, {
                          modelValue: _ctx.companyRecord.ccCustomerOn12aFollowUp,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.companyRecord.ccCustomerOn12aFollowUp) = $event))
                        }, null, 8, ["modelValue"]),
                        _cache[47] || (_cache[47] = _createElementVNode("div", { class: "label-beside-input-switch" }, "CC this customer on 14 days follow-up emails (12A requests)", -1))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createVNode(_component_Contacts, {
                title: "Contacts",
                contacts: _ctx.companyRecord.contacts,
                view: "toggle",
                canEdit: true
              }, null, 8, ["contacts"])
            ])
          ]),
          (!_ctx.newCompany)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_BillingEntities, {
                    title: "Billing Entities",
                    billingEntities: _ctx.companyRecord.billingEntities
                  }, null, 8, ["billingEntities"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          class: "sticky-button cancel",
          icon: "pi pi-times",
          label: _ctx.hasChanges ? 'Cancel' : 'Close',
          onClick: _ctx.cancel
        }, null, 8, ["label", "onClick"]))
      : _createCommentVNode("", true),
    (!_ctx.loading && !_ctx.newCompany)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 2,
          class: "sticky-button",
          icon: "pi pi-check",
          label: "Save",
          onClick: _ctx.save,
          disabled: !_ctx.hasChanges
        }, null, 8, ["onClick", "disabled"]))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.newCompany)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 3,
          class: "sticky-button",
          icon: "pi pi-check",
          label: "Add new record",
          onClick: _ctx.saveNewCompany
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ], 64))
}